













































































































import { Component, Prop, Vue } from "vue-property-decorator";
import VToolbar from "@/ui/common/components/VToolbar.vue";
import Invoice from "../../../usecases/orders/invoice";
import VIconEdit from "../../../components/icons/VIconEdit.vue";
import VIconPrint from "../../../components/icons/VIconPrint.vue";
import { client } from "@/api/request";
import InvoiceApi from "@/api/orders/invoice-api";
import PrintApi from "../../../api/orders/print-api";
import VSearchBar from "../../../components/VSearchBar.vue";
import InvoiceStatus from "../components/InvoiceStatus.vue";
import InvoiceService from "../../../usecases/orders/invoice-service";
import BillingRuleApi from "../../../orders/api/billing-rule-api";
import InvoiceSearchBar from "@/ui/common/components/InvoiceSearchBar.vue";
import InvoiceSearchOptions from "@/ui/common/presenters/invoice-search-options";
import SelectOption from "@/common/ui/presenters/select-option";
import { getAllProjects } from "@/api/project-api";
import { getAllCompanies } from "@/api/company-api";
import { getUserAriseServices, ServiceArise } from "@/api/service-api";
import ProjectOrderTabs from "@/components/ProjectOrderTabs.vue";

const printApi = new PrintApi(client);
const invoiceApi = new InvoiceApi(client);
const invoiceService = new InvoiceService(
  invoiceApi,
  new BillingRuleApi(client)
);

@Component({
  components: {
    ProjectOrderTabs,
    InvoiceStatus,
    VToolbar,
    VSearchBar,
    VIconEdit,
    VIconPrint,
    InvoiceSearchBar
  }
})
export default class InvoiceListPage extends Vue {
  @Prop() projectId?: string;
  @Prop({ type: Boolean }) edition!: boolean;
  invoiceItems: Invoice[] = [];
  query = "";
  printStatus: boolean[] = [];
  isAllSelected: boolean = false;
  selectedIds: number[] = [];
  projects: SelectOption[] = [];
  companies: SelectOption[] = [];
  startDate = "";
  endDate = "";
  selectProject = "";
  resetLoadInfinite = 0;
  roles: ServiceArise[] = [];

  statusOptions = [
    {
      text: "全て(ステータス)",
      value: ""
    },
    {
      text: "未請求",
      value: "created"
    },
    {
      text: "請求済み",
      value: "requested"
    },
    {
      text: "入金済み",
      value: "paid"
    }
  ];

  edit(id: number) {
    this.$router.push({
      name: "order-invoice-edit",
      params: {
        id: String(id)
      }
    });
  }

  searchOptions: InvoiceSearchOptions = {
    project: "",
    company: "",
    status: "",
    startDate: "",
    endDate: ""
  };

  // search(query: string) {
  //   this.query = query;
  //   this.loadInvoiceList();
  // }

  search() {
    this.initServiceRoles();
    this.initProjectList();
    this.initCompanyList();
    this.loadInvoiceList();
  }

  // ステータス変更
  async changeStatus(id: string, status: string) {
    await invoiceService.changeStatus(id, status);
    await this.initServiceRoles();
    await this.loadInvoiceList();
    await this.$store.dispatch("getStatusProject");
    await this.$store.dispatch("setProjectEstimateExpenseSummary");
  }

  get service() {
    return this.$store.state.service;
  }

  protected created() {
    this.initServiceRoles();
    this.initProjectList();
    this.initCompanyList();
    // this.loadInvoiceList(this.searchOptions); // 初回も自動ロードされる
  }

  get projectOptions() {
    return [
      {
        text: "全て(現場名)",
        value: ""
      },
      ...this.projects.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initProjectList() {
    this.projects = (await getAllProjects()).map(p => ({
      text: p.name,
      value: String(p.projectId)
    }));
  }

  get companyOptions() {
    return [
      {
        text: "全て(元請け)",
        value: ""
      },
      ...this.companies.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initCompanyList() {
    this.companies = (await getAllCompanies()).map(p => ({
      text: p.name,
      value: String(p.companyId)
    }));
  }

  private async initServiceRoles() {
    this.roles = await getUserAriseServices();
  }

  async createPdf(id: number, index: number, printsExcludeTax: boolean) {
    if (!this.printStatus.includes(true)) {
      this.$set(this.printStatus, index, true);
      let url: string;
      try {
        url = await printApi.getInvoicePrint(
          id,
          this.$store.state.accessToken,
          printsExcludeTax
        );
      } catch (e) {
        alert("印刷に失敗しました。");
        return;
      } finally {
        this.$set(this.printStatus, index, false);
      }
      window.open(url, "請求書印刷");
    } else {
      alert(
        "現在他の請求書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );
    }
  }

  async createAllPdf(index: number, printsExcludeTax: boolean) {
    if (!this.printStatus.includes(true)) {
      this.$set(this.printStatus, index, true);
      const url = await printApi.getInvoiceAllPrint(
        this.selectedIds,
        this.$store.state.accessToken,
        printsExcludeTax,
        this.searchOptions.project,
        this.searchOptions.company
      );
      this.$set(this.printStatus, index, false);
      window.open(url, "請求書印刷");
      await this.loadInvoiceList(this.searchOptions);
    } else {
      alert(
        "現在他の請求書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );
    }
  }

  currentOptions(options: InvoiceSearchOptions = {}, currentLength: number) {
    if (this.searchOptions.project) {
      this.selectProject = this.searchOptions.project;
    } else if (this.projectId) {
      this.selectProject = this.projectId;
    } else {
      this.selectProject = "";
    }
    return {
      ...options,
      projectId: this.selectProject,
      companyId: this.searchOptions.company,
      status: this.searchOptions.status,
      startDate: this.searchOptions.startDate,
      endDate: this.searchOptions.endDate,
      invoiceCount: currentLength
    };
  }

  async getInvoiceList30(options?: any) {
    // 現在の件数は、内容を表示している invoiceItems から直接取得
    const new_options = this.currentOptions(options, this.invoiceItems.length);
    return await invoiceApi.findAll(new_options);
  }

  private async loadInvoiceList(options?: any) {
    this.selectedIds = [];
    this.resetLoadInfinite += 1; // リロードリセット
    const new_options = this.currentOptions(options, 0); // 取得開始を0件に

    this.invoiceItems = await invoiceApi.findAll(new_options);
    for (let i = 0; i < this.invoiceItems.length; i++) {
      this.printStatus.push(false);
    }
  }

  /**
   * 最下部 自動リロード
   */
  // TODO: 表示条件変更時に、表示完了の際に 検索結果はありません が出てしまう事がある
  async loadInfinite($state: any) {
    const loadedInvoiceItems: Invoice[] = await this.getInvoiceList30(
      this.searchOptions
    );

    // 表示するデータがあれば結合して末尾に追加、なければ終了
    if (loadedInvoiceItems.length) {
      if (this.invoiceItems.length == 0) {
        this.invoiceItems = loadedInvoiceItems;
      } else {
        this.invoiceItems = this.invoiceItems.concat(loadedInvoiceItems);
      }
      for (let i = 0; i < this.invoiceItems.length; i++) {
        this.printStatus.push(false);
      }

      $state.loaded();
    } else {
      $state.complete();
    }
  }

  async selectAll() {
    if (this.isAllSelected) {
      this.selectedIds = [];
      this.isAllSelected = false;
    } else {
      this.selectedIds = [];
      for (const item in this.invoiceItems) {
        this.selectedIds.push(this.invoiceItems[item].id);
      }
      this.isAllSelected = true;
    }
  }
  async select() {
    this.isAllSelected = this.selectedIds.length === this.invoiceItems.length;
  }

  isNegative(value: number): boolean {
    return value < 0;
  }
}
